import type { BaseAnnotationT } from '../../common/types/types';
export type EntityTaggingDataT = {
  start: number;
  end: number;
};
export type ElementT = HTMLElement & {
  remove: () => void;
};
type EntityBaseAnnotationT = Omit<BaseAnnotationT, 'metadata'> & {
  metadata?: BaseAnnotationT['metadata'] & {
    refVideoLabel?: string;
  };
};
export type EntityTaggingAnnotationT = {
  annotationType: 'REGION';
  data: EntityTaggingDataT[];
} & EntityBaseAnnotationT;
export type EntityTaggingSingleAnnotationT = {
  annotationType: 'REGION';
  data: EntityTaggingDataT;
} & EntityBaseAnnotationT;
export type AnnotationT = EntityTaggingAnnotationT;